import type { RunProjectView } from "../api/hooks/useStatefulAgents";

const plural = (n: number, noun: string): string => `${n} ${noun}${n === 1 ? "" : "s"}`;

export interface WaitingCounts {
  /** Absent on a run's project response: decisions are shown in Next actions. */
  decisions?: number;
  emails: number;
  /** Agent feedback questions, where the surface counts them. */
  questions?: number;
}

/** "1 decision · 2 emails", or "" when nothing is waiting. Every surface that
 * says what a run left waiting says it this way. */
export const waitingLabel = (counts: WaitingCounts): string =>
  [
    counts.decisions && plural(counts.decisions, "decision"),
    counts.emails && plural(counts.emails, "email"),
    counts.questions && plural(counts.questions, "question"),
  ]
    .filter(Boolean)
    .join(" · ");

/** What a project's folded response says it holds. */
export const responseCounts = (project: RunProjectView): string =>
  waitingLabel(project.counts) || "nothing waiting on you";
